var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorAddGradableBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editor_add_gradable_branch_svg__clip0_1181_1858)",
    stroke: "#98BDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM10.25 8.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM10.25 8.5a5.25 5.25 0 005.25 5.25M3.25 15.5a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM10.25 8.5A5.25 5.25 0 015 13.75",
    strokeWidth: 1.167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.667 2.062L.611 5.118M.611 2.062l3.056 3.056M14.669 3.896l1.222 1.222 2.53-3.039",
    strokeWidth: 1.161
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editor_add_gradable_branch_svg__clip0_1181_1858"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 9.75 10.25)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgEditorAddGradableBranch;